module.exports = { id: "arrow-right-up", url: "/build/app/img/symbols.svg#arrow-right-up", viewBox: "", toString: function() { return this.url; } };